export const regionHasComponent = (region, layout, props) => {
  let hasComponent = false;
  props.post.components.forEach((item) => {
    if (item.layout === layout && item.region === region) {
      hasComponent = true;
    }
  })
  return hasComponent;
}